// import * as actions from '../actions/Labels';

const initialState = { name: 'tsuruta' };

const loginInfo = (state = initialState, action) => {
  switch (action.type) {
    // case actions.FETCH_USER_REQUEST:
    // case actions.FETCH_USER_SUCCESS:
    //   return Object.assign({}, state, { name: action.payload });
    default:
      return state;
  }
};

export default loginInfo;
